import TryRazeenPlusModal from "./try-razeen-plus-modal";
import ForceRazeenPlusModal from "./force-razeen-plus-modal";
import { finalDate } from "./count-down-timer";

export default function NewRazeenModalSwitch() {
  const now = new Date();

  const shiftDate = finalDate;

  if (now > shiftDate) {
    return <ForceRazeenPlusModal />;
  }

  return <TryRazeenPlusModal />;
}
